export default __webpack_public_path__ + "7160aa86841d1d17ce41cea4b2d53cf1.svg";